import { fabric } from "fabric"
import Calc from "@/common/util/calculator"
import BaseFixmethod from "@/signomatic/app/fixmethods/base"
import RectObject from "@/signomatic/app/objects/rect"
import GroupObject from "../objects/group"

export default class MilitaryFixmethod extends BaseFixmethod {
  get externalLeftPadding(): number {
    return Calc.mmToPx(10) * 0.75
  }

  bottomDrawable() {
    const { widthPx, heightPx } = this.state
    const width = Calc.mmToPx(10)

    const back = new RectObject({
      fill: "black",
      width,
      height: heightPx,
      left: 0 - widthPx / 2 - width / 4,
      rx: 3,
      ry: 3,
    })
    const counter = new RectObject({
      fill: "transparent",
      width,
      height: heightPx,
      left: 0 + widthPx / 2 + width / 4,
    })

    back.set(
      "fill",
      new fabric.Gradient({
        coords: {
          x1: 0,
          y1: 0,
          x2: back.width,
          y2: 0,
        },
        colorStops: [
          { offset: 0, color: "#8a8a8a" },
          { offset: 0.2, color: "#b8b7b7" },
          { offset: 0.8, color: "#b8b7b7" },
          { offset: 1, color: "#8a8a8a" },
        ],
      })
    )

    return new GroupObject([back, counter], { left: 0, top: 0, width: widthPx, height: heightPx })
  }
}
